export default {
  mounted(el, binding) {
    const { nodeName = 'TEXTAREA', enabled = true, pad = 0 } = binding.value;
    if (el.nodeName === nodeName && enabled) {
      el.style.height = el.scrollHeight + pad + 'px';
    }
  },
};
